import React, { Component } from 'react';
import axios from 'axios';
import { Configurations } from '../../../Utils/Configurations';
import { RelatorioEvolucao } from 'ebs-orders-reports-react-lib';
import ErrorModal from '../../../Components/ErrorModal/ErrorModal';


import '../Reports.scss';

export default class EvolutionReport extends Component {

    constructor() {
        super();

        this.getOrdersEvolution = this.getOrdersEvolution.bind(this);
        this.handleOrg = this.handleOrg.bind(this);
        this.handleError = this.handleError.bind(this);
        this.closeErrorModal = this.closeErrorModal.bind(this);
        this.totalSubscribes = this.totalSubscribes.bind(this);

        this.Configurations = new Configurations();

        this.state = {
            isLoadingMultiproduto: false,
            isLoadingTotal: false,
            orgSelecionada: '',
            hasError: false,
            errorMessage: '',
            flagOrganizacao: false


        }
    }
   

    getOrdersEvolution() {
        this.setState({ isLoadingMultiproduto: true });
        const _service = axios.get(this.Configurations.apiBasePath + `/relatorio/evolucao/evolucao-multi-produto?organizacao=${this.state.orgSelecionada}`);

        _service.then(response => {
            this.setState({
                graficoMultiproduto: response.data.evolucaoMultiproduto
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingMultiproduto: false
        }));
    }

    totalSubscribes() {
        this.setState({ isLoadingTotal: true });
        const _totalAssinaturas = axios.get(this.Configurations.apiBasePath + `/relatorio/evolucao/evolucao-total?organizacao=${this.state.orgSelecionada}`);

        _totalAssinaturas.then(response => {
            this.setState({
                graficoTotalAssinaturas: response.data.evolucaoTotal
            });
        }).catch(this.handleError).finally(() => this.setState({
            isLoadingTotal: false
        }));
    }

    handleOrg(eValue) {
        this.setState({ orgSelecionada: eValue }, () => {  
            this.getOrdersEvolution();
            this.totalSubscribes(); 
            this.setState({ flagOrganizacao: true })
        });
    }

    handleError(err) {
        this.setState({ hasError: true, errorMessage: err.response ? err.response.data.msg : 'Erro inesperado.' })
        console.log(err);
    }

    closeErrorModal() {
        this.setState({ hasError: false, errorMessage: "" })
    }

    render() {

        const {
            orgSelecionada
        } = this.state;

        return (
            <React.Fragment>
                <RelatorioEvolucao
                    handleOrg={this.handleOrg}
                    orgSelecionada={orgSelecionada}
                    apiBasePath={this.Configurations.apiBasePath}
                    graficoMultiproduto={this.state.graficoMultiproduto}
                    graficoTotalAssinaturas={this.state.graficoTotalAssinaturas}
                    isLoadingMultiproduto={this.state.isLoadingMultiproduto}
                    isLoadingTotal={this.state.isLoadingTotal}
                    tokenKey={this.Configurations.tokenKey}
                    flagOrganizacao={this.state.flagOrganizacao}
                />
                <ErrorModal
                    isOpen={this.state.hasError}
                    message={this.state.errorMessage}
                    closeErrorModal={this.closeErrorModal}
                />
            </React.Fragment>
        )
    }
}
